'use client';

import { createGrid as createGrid2 } from '@mui/system/Grid';
import { styled, useThemeProps as _useThemeProps } from "../styles/index.js";
/**
 *
 * Demos:
 *
 * - [Grid version 2](https://mui.com/material-ui/react-grid2/)
 *
 * API:
 *
 * - [Grid2 API](https://mui.com/material-ui/api/grid-2/)
 */
var Grid2 = createGrid2({
  createStyledComponent: styled('div', {
    name: 'MuiGrid2',
    slot: 'Root',
    overridesResolver: function overridesResolver(props, styles) {
      return styles.root;
    }
  }),
  componentName: 'MuiGrid2',
  useThemeProps: function useThemeProps(inProps) {
    return _useThemeProps({
      props: inProps,
      name: 'MuiGrid2'
    });
  }
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Grid2;